import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatLakhsOrCr } from "@/lib/utils";

export function DashboardBreakdownTable({
  data,
  columns,
  currency = true,
}: {
  data: Array<Record<string, string | number>>;
  columns: Array<{ key: string; label: string }>;
  currency?: boolean;
}) {
  const rows = data ?? [];

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Period</TableHead>
            {columns.map((column) => (
              <TableHead key={column.key} className="text-right">
                {column.label}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={columns.length + 1}
                className="py-8 text-center text-sm text-muted-foreground"
              >
                No data found.
              </TableCell>
            </TableRow>
          ) : (
            rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.month}</TableCell>
                {columns.map((column) => (
                  <TableCell key={column.key} className="text-right tabular-nums">
                    {currency
                      ? formatLakhsOrCr(Math.round(Number(row[column.key]) || 0))
                      : Math.round(Number(row[column.key]) || 0)}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
